"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.call = void 0;
var _chains_1 = require("../../chains");
var profile_1 = require("../../shared/utils/profile");
var promises = {};
var EXPIRES_IN = 10 * 1000;
function call(instance, method, options, msg) {
    if (options === void 0) { options = []; }
    if (msg === void 0) { msg = ''; }
    var trace;
    try {
        throw new Error();
    }
    catch (e) {
        trace = e.stack.split('\n').slice(0, 5);
    }
    var key = "".concat(String(method), ":").concat(instance.options.address, ":").concat(options.join(','));
    var errHandler = function (e) {
        var address = instance.options.address;
        // @ts-ignore
        var chainId = instance._provider.chainId;
        var chain = Object.values(_chains_1.chains).find(function (c) { return c.id === parseInt(chainId, 16); });
        var message = [
            "\"".concat(String(method), ".call()\" failed").concat(msg && ": ".concat(msg)),
            "Contract: ".concat(address),
            "Options: ".concat(options),
            "Chain: ".concat((chain === null || chain === void 0 ? void 0 : chain.name) || chainId),
            e.toString(),
            trace.join('\n'),
        ].join('\n');
        throw new Error(message);
    };
    try {
        var methodInstance = instance.methods[method];
        if (!promises[key]) {
            (0, profile_1.profileInc)('call', key);
            promises[key] = methodInstance.apply(void 0, options).call()
                .catch(errHandler);
            setTimeout(function () {
                promises[key] = null;
            }, EXPIRES_IN);
        }
        return promises[key];
    }
    catch (e) {
        errHandler(e);
    }
}
exports.call = call;
